$(function () {
  'use strict'
  AOS.init()

  $('.mobile-menu>li>a').click(function () {
    $('#mobileMenu').modal('hide')
  })
  // const embellish = $('.text-container, .embellish > .image-1')
  const player = videojs('home-player', {
    controlBar: {
      volumePanel: {
        inline: false
      }
    },
    playsinline: true
  })
  const videoContainer = $('.video-js')
  player.ready(function () {
    videoContainer.css('padding-top', '56.2%')
    videoContainer.css('width', '100%')
    setTimeout(() => {
      if (!player.paused()) {
        // embellish.css('opacity', 0)
        setTimeout(() => {
          videoContainer.css('z-index', 2)
        }, 2000)
      }
    }, 1000)
  })

  player.on('leavepictureinpicture', function (e) {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  })

  player.on('fullscreenchange', function (e) {
    if (player.isInPictureInPicture() && player.isFullscreen()) {
      player.exitPictureInPicture()
    }
  })

  let playerContainer = $('.video-container')
  let manualPause = 'play'

  playerContainer.on('click', (e) => {
    if (player.paused()) {
      manualPause = 'pause'
      // hide embellish
      // embellish.css('opacity', 1)
      videoContainer.css('z-index', 0)
    } else {
      manualPause = 'play'
      // show embellish
      // embellish.css('opacity', 0)
      videoContainer.css('z-index', 2)
    }
  })

  document.addEventListener('scroll', (e) => {
    if (playerContainer && playerContainer[0]) {
      const offsetTop = playerContainer[0].offsetTop,
        clientHeight = playerContainer[0].clientHeight
      const isInPictureInPicture = player.isInPictureInPicture()
      if (
        !isInPictureInPicture &&
        window.scrollY > offsetTop + clientHeight * 0.5
      ) {
        player.pause()
      } else {
        if (player.paused && manualPause !== 'pause') {
          player.play()
        }
      }
    }
  })
})

document.addEventListener('aos:in', ({ detail }) => {
  // console.log('aos in', detail);
  const target = $(detail)
  if (
    target.hasClass('work-bg-03') ||
    target.hasClass('bg-computer bg-computer-03')
  ) {
    $('.sticky-content').css('opacity', 0)
  } else if (target.hasClass('physical')) {
    $('.sticky-content').css('opacity', 1)
  }
})

document.addEventListener('aos:out', ({ detail }) => {
  // console.log('aos out', detail);
  const target = $(detail)
  if (target.hasClass('bg-computer bg-computer-03')) {
    $('.sticky-content').css('opacity', 1)
  } else if (target.hasClass('physical')) {
    $('.sticky-content').css('opacity', 0)
  }
})

/*
  flexible
*/
;(function (window) {
  /* design width */
  var docWidth = 750

  var doc = window.document,
    docEl = doc.documentElement,
    resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'

  var recalc = (function refreshRem() {
    var clientWidth = docEl.getBoundingClientRect().width
    if (clientWidth > 767) {
      docEl.style.fontSize = '16px'
    } else {
      /* 8.55：< 320px no longer narrow，11.2：> 420px no linger zoom */
      docEl.style.fontSize =
        Math.max(Math.min(20 * (clientWidth / docWidth), 11.2), 8.55) * 5 + 'px'
    }
    return refreshRem
  })()

  docEl.setAttribute(
    'data-dpr',
    window.navigator.appVersion.match(/iphone/gi) ? window.devicePixelRatio : 1
  )

  if (/iP(hone|od|ad)/.test(window.navigator.userAgent)) {
    doc.documentElement.classList.add('ios')
    if (
      parseInt(
        window.navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/)[1],
        10
      ) >= 8
    )
      doc.documentElement.classList.add('hairline')
  }

  if (!doc.addEventListener) return
  window.addEventListener(resizeEvt, recalc, false)
  doc.addEventListener('DOMContentLoaded', recalc, false)
})(window)
